import Image from "next/image";
import { NAV_HEIGHT, SCPB_LOGO } from "@/src/constants";
import { LinearProgress } from "@mui/material";
import { Transition } from "react-transition-group";
import { useEffect, useRef } from "react";
const TIMEOUT = 300;

const getTransitionStyles = {
  entering: {
    opacity: 1,
    transform: `translateY(50px)`,
    position: "fixed",
    width: "100%",
    height: "100%",
    zIndex: 10000,
    left: 0,
    top: NAV_HEIGHT,
  },
  entered: {
    transition: `opacity ${TIMEOUT}ms ease-in-out, transform ${TIMEOUT}ms ease-in-out`,
    opacity: 1,
    transform: `translateY(0px)`,
    animation: "blink .3s linear 2",
    position: "fixed",
    width: "100%",
    height: "100%",

    zIndex: 10000,
    left: 0,
    top: NAV_HEIGHT,
  },
  exiting: {
    transition: `opacity ${TIMEOUT}ms ease-in-out, transform ${TIMEOUT}ms ease-in-out`,
    opacity: 0,
    position: "fixed",
    width: "100%",
    height: "100%",

    zIndex: 10000,
    left: 0,
    top: NAV_HEIGHT,
  },
  exited: {
    transition: `opacity ${TIMEOUT}ms ease-in-out, transform ${TIMEOUT}ms ease-in-out`,
    opacity: 0,
    height: 0,
    display: "none",
  },
};
export interface LodingProps {
  isLoading: boolean;
}

const Loading = ({ isLoading }: LodingProps) => {
  const nodeRef = useRef(null);

  return (
    <Transition
      timeout={{
        enter: 0,
        exit: TIMEOUT,
      }}
      nodeRef={nodeRef}
      in={isLoading}
      appear={true}
    >
      {(status) => (
        <div
          //@ts-expect-error Get T
          style={{ ...getTransitionStyles[status] }}
          ref={nodeRef}
          className={`loading-container ${status} bg-slate-200`}
        >
          <div className="absolute top-0 left-0 h-[80vh] w-full">
            <div className="flex flex-col align-items items-center h-full w-full justify-center gap-4">
              <div className="w-[80%] min-h-[200px] relative">
                <Image src={SCPB_LOGO} alt="SCPB Logo" fill />
              </div>
              <LinearProgress style={{ width: "50%" }} />
            </div>
          </div>
        </div>
      )}
    </Transition>
  );
};

export default Loading;
